// packages/api/src/hooks/useConfirmData.ts
//
// Identity reconfirmation — POST /profile/confirm-data stamps the current
// user's identity_confirmed_at = now() (re-stamps on every call). On success we
// invalidate the auth/profile "me" caches so requires_data_confirmation flips
// to false and the blocking DataReconfirmationModal closes.
// Contract: docs/contracts/ESCR-identity-reconfirmation.md.

import { useMutation, useQueryClient } from '@tanstack/react-query';

import type { ApiSuccess, ConfirmDataResponse } from '@alamo/types';

import { apiClient } from '../client';
import { queryKeys } from '../query-keys';

export function useConfirmData() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (): Promise<ConfirmDataResponse> => {
      const res = await apiClient.post<ApiSuccess<ConfirmDataResponse>>('/profile/confirm-data');
      return res.data.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.auth.me });
      queryClient.invalidateQueries({ queryKey: queryKeys.profile.me() });
    },
  });
}
